import { Controller } from "@hotwired/stimulus"

// Backs the model field on the prompt editor. The <select> lists models from
// the RubyLLM registry plus a "__custom__" escape hatch; picking it reveals a
// text input for a model id the registry doesn't list.
//
// Exactly one control carries the `prompt[model]` name at a time, so the form
// posts a single unambiguous value. The server already renders that state
// correctly, so this controller only has to maintain it as the user switches —
// the field works with JS disabled.
//
// The select is never disabled: it is the only way back out of custom mode.
//
//   <div data-controller="prompt-model">
//     <select data-prompt-model-target="select" data-action="change->prompt-model#toggle">
//     <div data-prompt-model-target="customWrapper" hidden>
//       <input data-prompt-model-target="custom" disabled>
export default class extends Controller {
  static targets = ["select", "custom", "customWrapper"]
  static values = { customKey: { type: String, default: "__custom__" } }

  connect() {
    this.sync()
  }

  // Bound to the select's change event — same as sync, but moves the caret
  // into the custom input so you can type immediately. Kept out of connect()
  // so loading a page that's already in custom mode doesn't steal focus.
  toggle() {
    const focusCustom = this.sync()
    if (focusCustom) this.customTarget.focus()
  }

  sync() {
    const isCustom = this.selectTarget.value === this.customKeyValue

    this.customWrapperTarget.hidden = !isCustom
    // A disabled control is never submitted; clearing the name covers the
    // select, which must stay enabled so the user can switch back.
    this.customTarget.disabled = !isCustom
    this.customTarget.name = isCustom ? "prompt[model]" : ""
    this.selectTarget.name = isCustom ? "" : "prompt[model]"

    return isCustom
  }
}
